import React from "react";
import { useParams } from 'react-router-dom';
import BlogPost from "../Components/BlogPages/BlogPost"; 

function BlogPage() {
  const { id } = useParams(); // Get the dynamic route parameter

  return (
    <>
      <main>
        <article id="fullpage">
          <BlogPost id={Number(id)} />
        </article>
      </main>
    </>
  );
}

export default BlogPage;
